<template lang="pug">
div
    el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini')
        el-form-item(label='人员类别：', prop='personType')
            el-select(v-model='searchlist.parentPersonTypeId', placeholder='---请选择上级类别--', @change='personTypeChange')
                el-option(v-for='item in searchGroups', :key='item.id', :label='item.consultName', :value='item.id',:disabled="item.checked") 
            //- span(style="margin-right:20px;")
            //- el-select(v-model='searchlist.personTypeId', placeholder='---请选择类别名称--')
            //-     el-option(v-for='item in searchGroupsChild', :key='item.id', :label='item.consultName', :value='item.id')
 
        el-form-item(style='margin:0  0 0 20px;')
            el-button(size='mini',type='primary' @click='searchlistdata') 查询
        el-form-item(style='margin:0  0 0 20px;')
            el-button(size='mini', type='info' @click='chongZhi') 重置
    el-table(ref='multipleTablePeo', :data='tableData', :row-key="getRowKey",@selection-change="selectionChange"
     :header-cell-style="{ background: '#f8fafa' }", border='', align='center', current-row-key='', highlight-current-row='', 
      @select="handleSelectionsChange" @select-all="handleSelectionsChange")
        el-table-column(type='selection', align='center' ,:selectable="checkSelectable" )
        el-table-column(align='center', type='index', label='序号')
        el-table-column(align='center', prop='name', label='姓名')
        el-table-column(align='center', prop='sex', label='性别')
            template(scope="scope")
                        span(v-if="scope.row.sex == 0") 男
                        span(v-if="scope.row.sex == 1") 女
        //- el-table-column(align='center', prop='numberId', label='身份证号', width='250px')
        el-table-column(align='center', prop='phone', label='手机号')
        el-table-column(align='center', prop='parentPersonTypeName', label='类别', :show-overflow-tooltip="true")

    el-pagination(@size-change='handleSizeChange', @current-change='handleCurrentChange', :current-page='pageConfig.pageNo', :page-size='pageConfig.pageSize', layout='total, prev, pager, next, jumper', :total='pageConfig.total')

    .boontbtn
        el-button(type='primary', size='small', @click='createData', style='margin: 0 30px') 保存

</template>

<script>
import request from "../../../../utils/request.js";
import { getConsulTYpePersion, getTypeById_p } from "@/api/http.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "ViewPeople",
  props: ["fatherdata", "isshow",''],
  data() {
    return {
      //人员类别
      searchGroups: [],
      searchGroupsChild: [],
      searchlist: {},
      tableData: [],
      multipleSelection: {},
      tempData: [],
      // 分页配置
      pageConfig: {
        pageSize: 5,
        total: 0,
        pageNo: 1
      },
      getRowKey(row) {
        return row.id;
      },

      checkSelectable(row) {
        return true;
      },
      checkedData: [],
      multipleSelectionFarher: {},
      multipleSelectionClick: {} 
    };
  },
  methods: {
    //获取人员类别树状图
    async getPTypes() {
      var res = await getTypeById_p({
        pageNo: 1,
        pageSize: 9999,
        status: '0' 
      }); 
      if (res.content && res.content.list.length) {
        if (this.fatherdata && this.fatherdata.length) {
          let fatherdataIds = this.fatherdata.map(it => it.id);  
          res.content.list = res.content.list.map(element => {
            if (fatherdataIds.includes(element.id)) {
              element.checked = true;
            } else {
              element.checked = false;
            }
            return element;
          });
          this.searchGroups = res.content.list || [];
          this.searchlist.parentPersonTypeId = "";
        } else {
          this.searchGroups = res.content.list || [];
        }
        // fatherdata
      }
      this.getPageDatas();
    },
    //改变状态
    async personTypeChange(ids) {
      let res = await getTypeById_p({
        parentId: ids,
        pageSize: 9999,
        pageNo: 1
      });
      this.$set(this.searchlist, "personTypeId", "");
      if (res.content) {
        this.searchGroupsChild = res.content.list || [];
      }
      this.getPageDatas();
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.checkedData = [];
      this.multipleSelection = {};
      this.multipleSelectionFarher = {};
      this.multipleSelectionClick = {};
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      //   this.multipleSelection = {};
      this.tableData = [];
      this.$nextTick(() => {
        this.$refs.multipleTablePeo.clearSelection();
      });
      var res = await getConsulTYpePersion({
        ...this.searchlist,
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize, 
        approvalStatus: 1,
        status: 0,
        menuType: ""
      });

      // console.log(res)
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;

        if (res.content.list.length) {
          // 取出当前页数的选中table数据
          let hadTableData = [];
          if (this.choosedata && this.choosedata.length) {
            this.choosedata.forEach(row => {
              res.content.list.forEach(row1 => {
                if (row.id == row1.id) {
                  //   this.checkedData.push(row1);
                  hadTableData.push(row1);
                }
              });
            });
          }

          this.multipleSelectionFarher[this.pageConfig.pageNo] = hadTableData;
          //   第一次显示父级传进来的数据的回显,如果有选中则以实际为准
            console.log(this.multipleSelectionClick[this.pageConfig.pageNo]);
          if (!this.multipleSelectionClick[this.pageConfig.pageNo]) {
            this.multipleSelection[this.pageConfig.pageNo] = hadTableData;
          }

          let newpagedata = [];
          res.content.list.forEach(row1 => {
            this.multipleSelection[this.pageConfig.pageNo].forEach(row2 => {
              if (row1.id == row2.id) {
                //   this.checkedData.push(row1);
                newpagedata.push(row1);
              }
            });
          });
          this.multipleSelection[this.pageConfig.pageNo] = newpagedata;
          this.checkedData = newpagedata;
          this.checkedTable();
        }
      } else {
        console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    checkedTable() {
        console.log("checkedData==t", this.checkedData);
      this.$nextTick(() => {
        this.checkedData.forEach(checked => {
          this.$refs.multipleTablePeo.toggleRowSelection(checked, true);
        });
      });
    },

    handleSelectionsChange(val) {
      this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1;
      this.multipleSelection[this.pageConfig.pageNo] = val;
      console.log(this.multipleSelection[this.pageConfig.pageNo])
      this.tempData = val
      // this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1;
      // this.multipleSelection[this.pageConfig.pageNo] = val;
      // console.log(this.multipleSelection[this.pageConfig.pageNo])
    },
    selectionChange(val) {
      console.log(val);
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val; 
      this.getPageDatas();
    },
    chongZhi(){ 
      this.searchlist = {};
      this.getPageDatas();
    },
    //封装数据
    createData() { 
      console.log(this.multipleSelection);
      let newdata = [];
      for (const key in this.multipleSelection) {
        if (this.multipleSelection.hasOwnProperty(key)) {
          newdata = newdata.concat(this.multipleSelection[key]);
        }
      } 
      let personTypeObj = this.searchGroups 
      let objs = {
        parentPersonTypeId: personTypeObj.id,
        consultName: personTypeObj.consultName,
        persionArr: newdata
      }; 
      this.$emit("func", objs);
    }
  },
  mounted() {
    this.getPTypes();
  },
  watch: {
    isshow(val) {
      if (!val) {
        this.checkedData = [];
        this.multipleSelection = {};
        this.multipleSelectionFarher = {};
        this.multipleSelectionClick = {};
        this.searchlist = {};
        this.tableData = [];
        this.pageConfig.pageNo = 1;
      } else { 
        this.getPTypes();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>